import { ManageCompaniesTranslation } from 'locales/de/pages/Jobmarket/manageCompanies';

const en: ManageCompaniesTranslation = {
  approve: 'Approve',
  details: 'View Details',
  companyDetails: 'Company Details',
  invoiceAddress: 'Invoice address',
  company: 'Company',
  invoice: 'Invoice',
  faculties: 'Faculties',
  jobManagement: 'Job Management',
  cancelConfirm: {
    message: 'You made changes. Are you sure you want to drop them?',
    title: 'Really cancel?'
  },
  rejectConfirm: {
    message: 'Are you sure you want to reject this company? The company will be deleted!',
    title: 'Really reject?'
  },
  deleteConfirm: {
    message: 'Are you sure you want to delete this company?',
    title: 'Really delete?'
  },
  alerts: {
    saveSuccessful: 'The company was successfully updated.',
    saveFailed: 'The company could not be updated.',
    changeStateSuccessful: 'The company state was successfully updated.',
    changeStateFailed: 'The company state could not be updated.',
    deleteSuccessful: 'The company was successfully deleted.',
    deleteFailed: 'The company could not be deleted.'
  },
  logoUploadPlaceholder: 'Logo upload (optimal aspect ratio 5:3)',
  companyName: 'Company Name',
  registerDate: 'Date Of Registration',
  activeCompanies: 'Active companies',
  inactiveCompanies: 'Inactive companies',
  archivedCompanies: 'Archived companies',
  bannedCompanies: 'Banned companies',
  companyProfile: 'Company Profile',
  unbanCompany: {
    title: 'Unban {{name}}',
    message: 'Do you want to unban this company? It was banned for the following reasons:'
  },
  createCompany: 'Create company',
  agreeToNewsletter: 'I hereby agree to receive the job market newsletter'
};

export default en;
